import React, { useEffect, cloneElement, Fragment } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadQuestionListAction, clearAnsweringQuestionsAction, setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { clearTimeCountAction } from "../../../../redux/answeringQuestions/timeCount";
import { clearQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import Closer from "./Closer";
import QuestionListController from "./QuestionListController";
import AnswerListController from "./AnswerListController";
import Viewer from "../../learning/container/Viewer";
import QuestionTipHider from "../../learning/container/QuestionTipHider";
import ScribbleCleaner from "../../learning/container/ScribbleCleaner";
import ScribbleErase from "../../learning/container/ScribbleErase";
import GrammarReducer from "../../learning/container/GrammarReducer";
import Scribbler from "../../learning/container/Scribbler";
import KeypadShower from "../../learning/container/KeypadShower";
import Inputer from "../../learning/container/Inputer";
import KeyPresser from "../../learning/container/KeyPresser";
import KeyClicker from "../../learning/container/KeyClicker";
import NoteTaker from "../../learning/container/NoteTaker";
import AnswerEditorController from "../../learning/container/AnswerEditorController";
import Submitter from "./Submitter";
import NotEnteredAnswerChecker from "./NotEnteredAnswerChecker";
import OXPopupHider from "./OXPopupHider";
import Jumper from "./Jumper";

const AnsweringQuestionsInitializer = ( props ) => {

  const params = useParams();

  const dispatch = useDispatch();
  const loadQuestionList = payload => { dispatch( loadQuestionListAction( payload ) ) };
  const clearAnsweringQuestions = () => { dispatch( clearAnsweringQuestionsAction() ) };
  const clearTimeCount = () => { dispatch( clearTimeCountAction() ) };
  const clearQuestionView = () => { dispatch( clearQuestionViewAction() ) };
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };


  useEffect( () => {
    loadQuestionList( params.stageCode );
    return () => {
      clearAnsweringQuestions();
      clearTimeCount();
      clearQuestionView();
      if(answeringQuestions.isResumeYn) setAnsweringQuestions( { isResumeYn : false } );
    };
  }, [] );

  return cloneElement( props.children || <Fragment />, {
    Closer,
    QuestionListController,
    AnswerListController,
    Viewer,
    QuestionTipHider,
    ScribbleCleaner,
    ScribbleErase,
    GrammarReducer,
    Scribbler,
    KeypadShower,
    Inputer,
    KeyPresser,
    KeyClicker,
    NoteTaker,
    AnswerEditorController,
    Submitter,
    NotEnteredAnswerChecker,
    OXPopupHider,
    Jumper
  } );

};

export default AnsweringQuestionsInitializer;